import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {fetchInvoiceById} from "../../../../../../reduxLib/invoiceLib";

function InvoiceModal({
                          isOpen,
                          onClose,
                          delivery,
                          invoiceId,
                      }) {
    const dispatch = useDispatch();

    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!isOpen || !invoiceId) return;

        let ignore = false;

        const loadInvoice = async () => {
            try {
                setLoading(true);
                setError("");

                const result = await dispatch(
                    fetchInvoiceById(invoiceId)
                ).unwrap();

                if (!ignore) {
                    setInvoice(result);
                }
            } catch (err) {
                if (!ignore) {
                    setError("Could not load invoice details");
                }
            } finally {
                if (!ignore) {
                    setLoading(false);
                }
            }
        };

        loadInvoice();

        return () => {
            ignore = true;
        };
    }, [dispatch, isOpen, invoiceId]);

    if (!isOpen || !delivery) return null;

    const billToName =
        invoice?.billToName ?? delivery.orderOwnerName ?? "-";

    const billToEmail =
        invoice?.billToEmail ?? delivery.orderOwnerEmail ?? "-";

    const currency =
        invoice?.currency ?? "EUR";

    const handleIssue = () => {
        console.log("Issue invoice", invoice?.invoiceId ?? invoiceId);
        // εδώ μετά βάζουμε dispatch(issueInvoice(...))
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl relative">

                <div className="border-b px-6 py-4 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-custom-green">
                        Invoice Preview
                    </h2>

                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-black"
                    >
                        <i className="fa-solid fa-xmark text-xl"></i>
                    </button>
                </div>

                <div className="p-6">
                    {loading && (
                        <p className="text-gray-500 mb-4">
                            Loading invoice...
                        </p>
                    )}

                    {error && (
                        <p className="text-red-600 mb-4">
                            {error}
                        </p>
                    )}

                    <div className="mb-6">
                        <h3 className="text-lg font-semibold">
                            Customer
                        </h3>

                        <p>{billToName}</p>
                        <p>{billToEmail}</p>
                    </div>

                    <div className="border rounded-lg overflow-hidden">
                        <table className="w-full">
                            <thead className="bg-gray-100">
                            <tr>
                                <th className="text-left p-3">
                                    Description
                                </th>

                                <th className="text-left p-3">
                                    Value
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr className="border-t">
                                <td className="p-3">
                                    Invoice ID
                                </td>

                                <td className="p-3">
                                    {invoice?.invoiceId ?? invoiceId ?? "-"}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Invoice Number
                                </td>

                                <td className="p-3">
                                    {invoice?.invoiceNumber ?? "-"}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Date Created
                                </td>

                                <td className="p-3">
                                    {
                                        invoice?.dateCreated
                                            ? new Date(invoice.dateCreated).toLocaleString()
                                            : "-"
                                    }
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Bill To Name
                                </td>

                                <td className="p-3">
                                    {billToName}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Bill To Email
                                </td>

                                <td className="p-3">
                                    {billToEmail}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Order ID
                                </td>

                                <td className="p-3">
                                    #{invoice?.orderRelId ?? delivery.orderRelId}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Delivery Number
                                </td>

                                <td className="p-3">
                                    {delivery.delivery_Number}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Discount
                                </td>

                                <td className="p-3">
                                    {Number(invoice?.discount ?? 0).toFixed(2)}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3">
                                    Currency
                                </td>

                                <td className="p-3">
                                    {currency}
                                </td>
                            </tr>

                            <tr className="border-t">
                                <td className="p-3 font-semibold">
                                    Total
                                </td>

                                <td className="p-3 font-semibold">
                                    {currency}{" "}
                                    {Number(
                                        invoice?.total ??
                                        delivery.totalPrice ??
                                        0
                                    ).toFixed(2)}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="border-t px-6 py-4 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="border px-4 py-2 rounded-lg"
                    >
                        Close
                    </button>

                    <button disabled className="bg-custom-green text-white px-4 py-2 rounded-lg">
                        Download PDF
                    </button>

                    <button
                        onClick={handleIssue}
                        className="bg-custom-green text-white px-4 py-2 rounded-lg"
                    >
                        Issue
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InvoiceModal;